"use strict";

var pf = {};
var appFunctions = {
    expandMobile: function () {
        if ($('html').hasClass('animateMenu')) {
            $('html').removeClass('openMenu').addClass('closeMenu');
            $(".closeMenu").bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () { appFunctions.close(); });
        } else {
            $('html').addClass('openMenu').addClass('animateMenu');
        }
    },
    close: function () {
        if ($('html').hasClass('closeMenu')) {
            $('html').removeClass('closeMenu').removeClass('animateMenu');
        }
    },
    blur: function (e, placeholder) {        	
    	var element = $(e.currentTarget);
    	if(element.is(':empty') || element.html() === "<br>"){
    		element.html(placeholder);
    	}
    },
    focus: function(e, placeholder) {
    	var element = $(e.currentTarget);
    	if(element.html() === placeholder){
    		element.html("");
    	}
    },
    slideUp: function (elem) {
        elem.style.height = '0px';
        this.once(1, function () {
            elem.style.opacity = '0';
        });
    },
    slideDown: function (elem, height) {
    	
    	var children = elem.children.length;
		height = children * height;
    	
        elem.style.height = height + 'px';
        elem.style.opacity = '1';
    },
    once: function () {
        var counter = 0;
        var time = window.setInterval(function () {
            counter++;
            window.clearInterval(time);
        }, 700);
    },
    closeMobile: function () {
    	if ($('html').hasClass('openMenu')) {
            appFunctions.expandMobile();
        }
    }
};

require.config({
    waitSeconds: 15,
    paths: {
        require: "//cdnjs.cloudflare.com/ajax/libs/require.js/2.1.15/require.min.js",
        jquery: "vendors/jquery/2.1.1/jquery.min",
        jqueryui: "vendors/jquery/ui/1.10.3/jquery-ui.custom.min",
        underscore: "vendors/underscore/1.5.2/underscore-min",
        underscorestring: "vendors/underscore/underscore.string",
        backbone: "vendors/backbone/1.1.0/backbone-min",
        marionette: "vendors/backbone/marionette/1.4.0/backbone.marionette.min",
        backbonevalidation: "vendors/backbone/validation/0.9.1/backbone-validation-amd-min",
        text: "vendors/text.min",
        //tpl: "vendors/tpl",
        css: "vendors/requireJS/require-css/0.1.1/css.min",
        localStorage: "vendors/backbone/localStorage/1.1.7/backbone.localStorage-min",
        cookie: "vendors/jquery/cookie/1.4.1/jquery.cookie",
        date: "vendors/date",
        moment: "vendors/moment/2.8.3/moment.min",
        has: "vendors/has",
        syphon: "vendors/backbone/syphon/0.4.1/backbone.syphon.min",
        md5: "vendors/md5",
        browserfingerprint: "vendors/browserfingerprint/1.1/browserfingerprint.min",
        colorbox: "vendors/jquery/colorbox/jquery.colorbox-min",
        watermark: "vendors/jquery/watermark/jquery.watermark.min",
        spin: "vendors/spin/spin.min",
        jspin: "vendors/spin/jquery.spin",
        //mediaqueries: "vendors/css3-mediaqueries",
        jqueryuiwidget: "vendors/jquery/fileupload/jquery.ui.widget",
        //iframetransport: "vendors/jquery/fileupload/jquery.iframe-transport",
        fileupload: "vendors/jquery/fileupload/jquery.fileupload",
        chosen: "vendors/jquery/chosen/1.0.0/chosen.jquery",
        //ddslick: "vendors/jquery/ddslick/2.0/ddslick.min",
        //recaptcha: "vendors/recaptcha",
        //freeTheCookies: "vendors/jquery.freeTheCookies",
        device: "vendors/device/device",
        tooltipster: "vendors/jquery/tooltipster/jquery.tooltipster",
        //basicauth: "vendors/backbone/basicauth/0.4.0/backbone.basicauth"
        modernizr: "vendors/modernizr-2.6.2.min",
        jsencrypt: "vendors/jsencrypt/jsencrypt.min",
        highcharts: "vendors/highcharts/highcharts",
        highchartsFunnel: "vendors/highcharts/modules/funnel",
        datetimepicker: "vendors/jquery/datetimepicker/2.2.9/jquery.datetimepicker",
        //jspdf: "vendors/jsPDF/0.9.0rc2/dist/jspdf.min",
        //notifier: "vendors/backbone/notifier/0.2.5/js/Backbone.Notifier.custom.min"
        //paginator: "vendors/backbone/paginator/2.0.0/backbone.paginator.min",
        jqpagination: "vendors/jquery/jqpagination/jquery.jqpagination",
        autosizemaster: "vendors/jquery/autosizemaster/jquery.autosize.min",
        analytics: "vendors/backbone/analytics/backbone.analytics",
        subroute: "vendors/backbone/subroute/0.4.3/backbone.subroute.min",
        routefilter: "vendors/backbone/routefilter/0.2.0/backbone.routefilter.min",
        jAlert: "vendors/jquery/alerts/1.1/jquery.alerts",
        //cropper: "vendors/jquery/cropper/cropper.min"
        sticky: "vendors/jquery/jquerysticky/1.0.1/jquery.sticky",
        //scrollable: "vendors/jquery/scrollable/1.7.1/scrollable"
        // ellipsis: "vendors/jquery/ellipsis/jquery.ellipsis.min",
        // dotdotdot: "vendors/jquery/dotdotdot/jquery.dotdotdot.min",
        fancybox: "vendors/jquery/fancybox/jquery.fancybox",
        tokenfield: "vendors/jquery/tokenfield/jquery.token-field",
        fullcalendar: "vendors/jquery/fullcalendar/fullcalendar.min",
        timepicker: "vendors/jquery/datetimepicker/2.2.9/jquery.timepicker",
        combodate: "vendors/jquery/combodate/combodate",
        jqueryvalidate: "vendors/jquery/jqueryvalidate/jquery.validate",
        // owlcarousel: "vendors/owlcarousel/owl.carousel.min.js"
        bootstrap: "vendors/bootstrap/3.3.7/bootstrap.min",
        // bootstrap: "vendors/bootstrap/3.3.7/carousel",
        async: "vendors/plugins/async",
        bluebird: "vendors/bluebird/3.5.0/bluebird.min",
        snap: "vendors/snap/snap.svg-min",
        hammer: "vendors/hammer/hammer",
        barcode: "vendors/barcode/JsBarcode.all.min",
        deepmerge: "vendors/deepmerge/deepmerge-2.2.1"
},
    shim: {
        require: { exports: "require" },
        jquery: { exports: "jQuery" },
        jqueryui: { deps: ["jquery"], exports: "jqueryui" },
        underscore: { exports: "_" },
        underscorestring: { exports: "underscorestring" },
        backbone: { deps: ["jquery", "underscore"], exports: "Backbone" },
        marionette: { deps: ["jquery", "underscore", "backbone"], exports: "Backbone.Marionette" },
        backbonevalidation: { deps: ["jquery", "underscore", "backbone"], exports: "backbonevalidation" },
        localStorage: { deps: ["backbone"], exports: "localStorage" },
        cookie: { deps: ["jquery"], exports: "Cookie" },
        date: { deps: ["jquery"], exports: "Date" },
        syphon: { deps: ["backbone"], exports: "syphon" },
        md5: { exports: "md5" },
        browserfingerprint: { deps: ["jquery", "md5"], exports: "browserfingerprint" },
        colorbox: { deps: ["jquery"], exports: "colorbox" },
        watermark: { deps: ["jquery"], exports: "watermark" },
        spin: { deps: ["jquery"], exports: "spin" },
        jspin: { deps: ["jquery", "spin"], exports: "jspin" },
        //mediaqueries: { exports: "mediaqueries" },
        jqueryuiwidget: { deps: ["jquery"], exports: "jqueryuiwidget" },
        //iframetransport: { deps: ["jquery", "jqueryuiwidget"], exports: "iframetransport" },
        fileupload: { deps: ["jquery", "jqueryuiwidget"], exports: "fileupload" },
        chosen: { deps: ["jquery"], exports: "chosen" },
        //ddslick: { deps: ["jquery"], exports: "ddslick" },
        //recaptcha: { exports: "recaptcha" },
        //freeTheCookies: { deps: ["jquery"], exports: "freeTheCookies" },
        device: { exports: "device" },
        tooltipster: { deps: ["jquery"], exports: "tooltipster" },
        modernizr: { deps: ["jquery"], exports: "modernizr" },
        jsencrypt: { exports: "jsencrypt" },
        highcharts: { deps: ["jquery"], exports: "highcharts" },
        highchartsFunnel: { deps: ["jquery", "highcharts"], exports: "highchartsFunnel" },
        datetimepicker: { deps: ["jquery"], exports: "datetimepicker" },
        //jspdf: { exports: "jspdf" },
        //notifier: { deps: ["backbone"], exports: "notifier" }
        //paginator: { deps: ["backbone"], exports: "paginator" },
        jqpagination: { deps: ["jquery"], exports: "jqpagination" },
        autosizemaster: { deps: ["jquery"], exports: "autosizemaster" },
        analytics: { deps: ["backbone"], exports: "analytics" },
        subroute: { deps: ["backbone"], exports: "subroute" },
        routefilter: { deps: ["backbone"], exports: "routefilter" },
        jAlert: { deps: ["jquery"], exports: "jAlert" },
        //cropper: { deps: ["jquery"], exports: "cropper" }
        sticky: { deps: ["jquery"], exports: "sticky" },
        //scrollable: { deps: ["jquery"], exports: "scrollable" }        
        // ellipsis: { deps: ["jquery"], exports: "ellipsis" },
        // dotdotdot: { deps: ["jquery"], exports: "dotdotdot" }
        fancybox: { deps: ["jquery"], exports: "fancybox" },
        tokenfield: { deps: ["jquery"], exports: "tokenfield" },
        fullcalendar: { deps: ["jquery", "jqueryui"], exports: "fullcalendar" },
        timepicker: { deps: ["jquery"], exports: "timepicker" },
        combodate: { deps: ["jquery"], exports: "combodate" },
        jqueryvalidate: { deps: ["jquery"], exports: "jqueryvalidate" },
        // owlcarousel: { deps: ["jquery"], exports: "owlcarousel" }
        bootstrap: { deps: ["jquery"], exports: "bootstrap" },
        bluebird: { deps: ["jquery"], exports: "bluebird" },
        hammer: { exports: "Hammer" },
        snap: { exports: "Snap" },
        barcode: { exports: "JsBarcode" },
        deepmerge: { exports: "deepmerge" }
    },
    deps: ["jquery", "jqueryui", "underscore", "underscorestring", "backbone", "marionette", "syphon", "cookie", "date", "moment", "datetimepicker", "browserfingerprint", "colorbox", "watermark", "jspin", "chosen", "backbonevalidation", "localStorage", "device", "tooltipster", "modernizr", "jsencrypt", "highcharts", "highchartsFunnel", "analytics", "routefilter", "subroute", "jAlert", "common/general", "common/enums", "common/models", "common/pfdialog", "sticky", "tokenfield", "timepicker", "combodate", "jqueryvalidate", "bootstrap", "common/apigconfig", "bluebird", "hammer", "snap", "barcode", "deepmerge"]
});

require(['app', 'routers/_payforward', 'map'], function(App, PFRouter, Maps){
    'use strict';

    $.ajaxSetup({
        timeout: 60000,
        beforeSend: function (xhr, settings) {
            if (typeof settings.external === "undefined") {
                xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
                xhr.setRequestHeader("x-content-type-options", "nosniff");
                //xhr.setRequestHeader("Accept-Encoding", "gzip");

                var d = new Date()
                var offset = d.getTimezoneOffset();
                xhr.setRequestHeader("X-TimezoneOffset", offset);
                if (pf.apikey != null)
                    xhr.setRequestHeader("ApiKey", pf.apikey);
            }
        },
        complete: function () {}
    });
    //jQuery.support.cors = true;
    
    App.controller = new PFRouter();
    App.enums = enums;
    App.apigconfig = apigconfig;
    App.maps = Maps;
    pf = App;
    App.controller.route('ping/:query/p:num', 'ping_name', function(query, num){
        console.log('PING FIRED',query,num,this);
    });
    App.start();



    $("#screen").click(function () {
        appFunctions.closeMobile();
    });

    initializeEnvironment();
});
define("main", function(){});

